export default "__VITE_ASSET__Dfqmw0wf__"